var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "px-1 border-bottom" }, [
    _c("div", { staticClass: "form-wrapper" }, [
      _c(
        "p",
        { staticClass: "lead mb-0", staticStyle: { "font-weight": "bold" } },
        [_vm._v("Promo Code")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c(
          "label",
          {
            staticStyle: { "font-weight": "normal" },
            attrs: { for: "promo-code" }
          },
          [
            _vm._v(
              "Have a promo code? Enter it below to apply the discount to your order."
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "input-group" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.enteredPromoCode,
                expression: "enteredPromoCode"
              }
            ],
            staticClass: "form-control",
            attrs: {
              name: "promo_code_entered",
              placeholder: "Enter your promo code here"
            },
            domProps: { value: _vm.enteredPromoCode },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.enteredPromoCode = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "input-group-append" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-success btn-sm",
                attrs: { type: "button", disabled: _vm.disableButton },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.validatePromoCode($event)
                  }
                }
              },
              [_vm._v("Apply")]
            )
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _vm.validating
      ? _c("div", { staticClass: "alert alert-success mb-1 text-left" }, [
          _c("p", { staticClass: "alert-text mb-0" }, [
            _vm._v("Validating your promo code...")
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.selectedPromoCode
      ? _c("div", { staticClass: "alert alert-success mb-1 text-left" }, [
          _c("p", { staticClass: "alert-text mb-0" }, [
            _c("strong", [_vm._v("Success!")]),
            _vm._v(" Promo code "),
            _c("b", [_vm._v(_vm._s(_vm.selectedPromoCode.code))]),
            _vm._v(" has been applied to your order.")
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.invalid
      ? _c("div", { staticClass: "alert alert-danger mb-1 text-left" }, [
          _c("p", { staticClass: "alert-text mb-0" }, [
            _c("strong", [_vm._v("Ooops!")]),
            _vm._v(" "),
            !_vm.missingRequiredProduct &&
            !_vm.belowMinimumOrderPrice &&
            !_vm.promoCodeHasBeenUsedByUser
              ? _c("span", [
                  _vm._v(
                    "Looks like we don't have any promo codes that match the one you entered."
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.belowMinimumOrderPrice
              ? _c("span", [
                  _vm._v("Looks like you need to spend "),
                  _c("b", [_vm._v("$" + _vm._s(_vm.belowMinimumOrderPrice))]),
                  _vm._v(" or more to use this promo code.")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.missingRequiredProduct
              ? _c("span", [
                  _vm._v("Looks like you need to have "),
                  _c(
                    "a",
                    {
                      staticClass: "text-danger",
                      attrs: { href: _vm.missingRequiredProductLink }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.missingRequiredProduct.ProductName2) +
                          " (" +
                          _vm._s(_vm.missingRequiredProduct.ProductSize) +
                          ")"
                      )
                    ]
                  ),
                  _vm._v(" in your cart to use this promo code.")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.promoCodeHasBeenUsedByUser
              ? _c("span", [
                  _vm._v(
                    "Looks like you've already used this single-use promo code on a previous order."
                  )
                ])
              : _vm._e()
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }